<template>
  <div class="condition f--c">
    <div class="f--c">
      <el-select v-model="groupItem.conditionCode" size="medium" style="width:180px;margin-right:10px" @change="e => change(e, 'conditionCode')">
        <el-option v-for="item in conditionList" :key="item.conditionCode.code" :value="item.conditionCode.code" :label="item.conditionCode.name"></el-option>
      </el-select>

      <el-select v-model="groupItem.operationCode" size="medium" :disabled="!groupItem.conditionCode" style="width:130px;margin-right:10px">
        <el-option v-for="item in relation" :key="item.code" :value="item.code" :label="item.name"></el-option>
      </el-select>

      <!-- 1选择框，2输入框，3无，4多选框，5多行文本框，6日期选择框，7-多文本框，8-数字文本框，9树形结构； -->
      <div>
        <el-select v-if="+groupItem.widgetType === 1" v-loading="selectLoading" v-model="groupItem.value[0]" filterable size="medium" :disabled="!groupItem.conditionCode" style="width: 380px" @focus="focusHandle">
          <el-option v-for="item in valueList" :key="item" :value="item" :label="item"></el-option>
        </el-select>
        <el-input v-if="+groupItem.widgetType === 2" v-model="groupItem.value[0]" size="medium" :disabled="!groupItem.conditionCode" placeholder="请输入" style="width: 380px"></el-input>
        <el-select v-if="+groupItem.widgetType === 4" v-loading="selectLoading" v-model="groupItem.value" filterable multiple collapse-tags size="medium" :disabled="!groupItem.conditionCode" style="width: 380px" @focus="focusHandle">
          <el-option v-for="item in valueList" :key="item" :value="item" :label="item"></el-option>
        </el-select>
        <el-date-picker
         v-if="+groupItem.widgetType === 6"
          v-model="date"
          type="datetimerange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="medium"
          @change="changeDate"
          style="width:380px">
        </el-date-picker>
        <div v-if="+groupItem.widgetType === 7">
          <el-input-number v-model="groupItem.value[0]" controls-position="right" :min="0" :precision="0" size="medium" placeholder="最小值" style="width:160px"></el-input-number> ~
          <el-input-number v-model="groupItem.value[1]" controls-position="right" :min="+groupItem.value[0]||1" :precision="0" size="medium" placeholder="最大值" style="width:160px" @blur="$set(groupItem.value, '1', groupItem.value[1]<groupItem.value[0]?groupItem.value[0]:groupItem.value[1])"></el-input-number>
        </div>
        <el-input-number v-if="+groupItem.widgetType === 8" v-model="groupItem.value[0]" controls-position="right" :min="0" :precision="0" size="medium" placeholder="输入数值"></el-input-number>
        <el-cascader v-if="+groupItem.widgetType === 9" placeholder="请选择品类" size="medium" :options="categoryOptions" :props="{ multiple: true, value: 'categoryId', label: 'name', children: 'childList', emitPath: false }" :show-all-levels="false" filterable collapse-tags clearable v-model="categoryValue" @change="selectCategory" style="width:380px">
          <template slot-scope="{ node, data }">
            <span>{{ data.name }}</span>
            <span v-if="!node.isLeaf"> ({{ data.childList.length }}) </span>
          </template>
        </el-cascader>
      </div>
    </div>
    <div v-if="showDelete" class="f-c-c pointer" style="margin-left:30px;width:30px;height:30px" @click="deleteHandle"><i class="iconfont icon-a-delete-bin-6-line5"></i></div>
  </div>
</template>

<script>
import API from '@/api';
import moment from 'moment'
import _ from 'lodash'
export default {
  props: {
    conditionList: {
      type: Array,
      default: () => []
    },
    groupItem: {
      type: Object,
      default: () => {}
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    categoryOptions: {
      type: Array,
      default: () => []
    },
    condition: {
      type: Object,
      default: () => []
    },
  },
  data() {
    return {
      relation: undefined,
      valueList: [],
      date: [],
      selectLoading: false,
      categoryValue: [],
      ruleList: [], // 所有规则
    }
  },
  computed: {
    // 选择的分类不可重复
    isSelect() {
      return (code) => {
        let ruleList = []
        this.condition.rules.forEach(item => {
          ruleList.push(item)
        })
        this.condition.groups && this.condition.groups.forEach(items => {
          items.rules.forEach(item => {
            ruleList.push(item)
          })
        })
        ruleList = ruleList.map(item => item.conditionCode)
        return ruleList.includes(code)
      } 
    }
  },
  created() {
  },
  mounted() {
    this.conditionList.forEach(item => {
      if (this.groupItem.conditionCode === item.conditionCode.code) {
        this.relation = _.cloneDeep(item.operationJson)
        if (this.groupItem.widgetType === 6) {
          this.date = this.groupItem.value.map(item => +item)
        }
        if (this.groupItem.widgetType === 9) {
          this.categoryValue = this.groupItem.value
        }
      }
    })
    
  },
  methods:{
    change(e) {
      console.log(this.relation)
      // widget：1选择框，2输入框，3无，4多选框，5多行文本框，6日期选择框，7-多文本框，8-数字文本框，9树形结构；
      this.$set(this.groupItem, 'operationCode', undefined),
      this.$set(this.groupItem, 'value', []),
      this.conditionList.forEach(item => {
        if (e === item.conditionCode.code) {
          this.relation = _.cloneDeep(item.operationJson)
          this.$set(this.groupItem, 'widgetType', item.widgetType.widget)
          // if ([1, 4].includes(+item.widgetType.widget)) {
          //   this.getAlbumModuleConditionSelect()
          // }
          this.delayering()
        }
      })
    },
    focusHandle() {
      this.selectLoading = true
      this.conditionList.forEach(item => {
        if (this.groupItem.conditionCode === item.conditionCode.code) {
          this.getAlbumModuleConditionSelect(item.widgetType.type)
        }
      })
    },

    delayering() {
      let ruleList = []
      this.condition.rules.forEach(item => {
        ruleList.push(item)
      })
      this.condition.groups && this.condition.groups.forEach(items => {
        items.rules.forEach(item => {
          ruleList.push(item)
        })
      })
      this.$set(this.$data, 'ruleList', ruleList.map(item => item.conditionCode))
    },

    changeDate(time) {
      this.$set(this.groupItem, 'value', [moment(time[0], 'YYYY-MM-DD HH:mm:ss').valueOf(), moment(time[1], 'YYYY-MM-DD HH:mm:ss').valueOf()])
    },
    // 条件下拉值
    getAlbumModuleConditionSelect(type) {
      API.getAlbumModuleConditionSelect(type).then(res => {
        this.valueList = res.data
      }).finally(() => {
        this.selectLoading = false
      })
    },

    // 筛选 - 商品品类级联选择器选中值发生变化时的回调
    selectCategory(value) {
      this.$set(this.groupItem, 'value', !value.length ? [] : value)
    },

    deleteHandle() {
      this.$emit('deleteCondition')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>